import { render, staticRenderFns } from "./ComOrder2.vue?vue&type=template&id=abe4950e&scoped=true&"
import script from "./ComOrder2.vue?vue&type=script&lang=js&"
export * from "./ComOrder2.vue?vue&type=script&lang=js&"
import style0 from "./ComOrder2.vue?vue&type=style&index=0&id=abe4950e&prod&lang=css&"
import style1 from "./ComOrder2.vue?vue&type=style&index=1&id=abe4950e&prod&scoped=true&lang=css&"
import style2 from "./ComOrder2.vue?vue&type=style&index=2&id=abe4950e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe4950e",
  null
  
)

export default component.exports